// extracted by mini-css-extract-plugin
export var dividerContainer = "_8l-0";
export var line = "_8l-1";